import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/service-charge";
const options = {role: ROLE.RESTAURANT};


export const editServiceCharge = async (values) => {
  return await axiosInstance(options).put(`${path}/edit`, values);
};